import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Hero from '@/components/Hero'
import Features from '@/components/Features'
import HowItWorks from '@/components/HowItWorks'
import LiveFeed from '@/components/LiveFeed'
import Link from 'next/link'

export default function Home() {
  return (
    <>
      <Header />
      <LiveFeed />
      <main>
        <Hero />
        <Features />
        <HowItWorks />

        {/* Community CTA Section */}
        <section style={{ padding: '80px 24px', textAlign: 'center' }}>
          <div style={{
            maxWidth: '700px', margin: '0 auto',
            background: 'linear-gradient(135deg, rgba(124,58,237,0.15), rgba(6,182,212,0.15))',
            border: '1px solid rgba(124,58,237,0.3)',
            borderRadius: '24px', padding: '60px 40px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '24px' }}>🚀</div>
            <h2 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '16px' }}>
              Ready to Launch Your <span className="gradient-text">Token?</span>
            </h2>
            <p style={{ color: '#94a3b8', fontSize: '16px', marginBottom: '36px', lineHeight: '1.7' }}>
              Join hundreds of projects already launched on VDC Chain. No code, no hassle — just deploy.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link href="/create" style={{
                padding: '14px 32px', borderRadius: '12px', textDecoration: 'none',
                background: 'linear-gradient(135deg, #7c3aed, #06b6d4)',
                color: 'white', fontWeight: '700', fontSize: '16px',
                boxShadow: '0 8px 25px rgba(124,58,237,0.4)'
              }}>🚀 Create Token</Link>
              <Link href="/explore" style={{
                padding: '14px 32px', borderRadius: '12px', textDecoration: 'none',
                background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
                color: '#e2e8f0', fontWeight: '600', fontSize: '16px'
              }}>🔍 Explore All Tokens</Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}
